import Schema from '../Schema';
import ShoppingCoupons from './ShoppingCoupons';

const ShoppingDiscounts = new Schema({
  _id: String,

  created_at: {
    type: Date,
    default: null
  },

  within_period: Boolean,

  // 使用するクーポン
  coupon: {
    type: String,
    ref: ShoppingCoupons
  },

  display_use_start: {
    date: String,
    datetime: String,
    time: String,
    timezone: String
  },

  display_expires: {
    date: String,
    datetime: String,
    time: String,
    timezone: String
  }
});

export default ShoppingDiscounts;
